import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Extracts the day of month (1-31) from an ISO 8601 date or date-time string.
 *
 * Supported inputs:
 * - Date-only: YYYY-MM-DD
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Returns the numeric day (1-31).
 * Throws if the input is not a valid ISO date/date-time in one of the above forms.
 */
export function getDayOfMonth<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): number {
  const {day} = deconstructDate(input);
  if(!day)
    throw new Error('getHour: invalid ISO date/date-time string');
  return day;
}

